module.exports = __webpack_public_path__ + "3ace38ede7310658b4ac70bba33fa26a.svg";